import React from "react";
import styles from "./order.module.scss";
import {  postCall, formatDate } from "../../../utils/utils";

const Index = ({
  scooter_img = "",
  model = "",
  customer_name = "",
  status = "",
  orderData
}) => {

  const handleEXOrder = () => {
    const url = JSON.parse(localStorage.getItem('env_const'))?.purchase_url || ""
    postCall(`${url}/cloakCustomer`, {
      redirectUrl: `/orderDetail?show=order_detail&orderID=${orderData?.order_id}`,
      buyer_utm_uuid: orderData?.user_id,
      buyer_name: orderData?.customer_name
    })
  }
  return (
    <div className={styles["wrapper"]} onClick={handleEXOrder}>
      <div className={styles["left"]}>
        <img src={scooter_img} alt="scooter" />
        <div>
          <h4>{model}</h4>
          <p>{customer_name}</p>
          <p>{status} | {formatDate(orderData?.updated)}</p>
          <p>{orderData?.order_id}</p>
        </div>
      </div>
      <div className={styles["right"]}>
        <img
          src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/images/arrow-black.svg"
          alt="arrow"
        />
      </div>
    </div>
  );
};

export default Index;
